import { useAppDataContext } from "utils/context";

export const useBarGraphs = () => {
  const {
    appData: { barGraphs },
  } = useAppDataContext();

  return { barGraphs };
};
